module.exports = __webpack_public_path__ + "media/attorney_resource_center/plaintiff-guide-book-center-4f2e6584.png";